declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string>;
  }
}

export function getRuntimeConfig(key: string): string {
  if (
    typeof window !== 'undefined' &&
    window.__RUNTIME_CONFIG__ &&
    Object.prototype.hasOwnProperty.call(
      window.__RUNTIME_CONFIG__,
      key,
    )
  ) {
    return window.__RUNTIME_CONFIG__[key] ?? '';
  }

  try {
    return (
      process.env as Record<
        string,
        string | undefined
      >
    )[key] ?? '';
  } catch {
    return '';
  }
}